export type OpenDirection = {
  horizontal: 'left' | 'right';
};

export type Position = {
  top: number;
  left: number;
  bottom: number;
  right: number;
};

export type SubMenuPosition = {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
};
